module.exports = __webpack_public_path__ + "static/img/switchNoActive.6437bd30.png";